import { Stack, Typography } from '@mui/material';
import { FC } from 'react';

interface StoreInfoProps {
    title: string;
    content: string;
}

export const StoreInfo: FC<StoreInfoProps> = ({ title, content }) => {
    return (
        <Stack
            direction="row"
            sx={{
                alignItems: 'center',
                gap: 2,
            }}
        >
            <Typography variant="subtitle1">{title}</Typography>
            <Typography>{content}</Typography>
        </Stack>
    );
};
